import { render } from "./page-profile.vue?vue&type=template&id=2adb93a0&scoped=true"
import script from "./page-profile.vue?vue&type=script&lang=js"
export * from "./page-profile.vue?vue&type=script&lang=js"

import "./page-profile.vue?vue&type=style&index=0&id=2adb93a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2adb93a0"]])

export default __exports__